<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.50403 5.57007L15.934 12.0001L9.50403 18.4301" :stroke="color" stroke-width="0.7" stroke-miterlimit="10"
          stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<script>
export default {
  name: 'ChevronRighticon',
  props: {
    color: {
      type: String,
      default: '#636363',
    },
  },
};
</script>